import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import type { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

/**
 * This decoration plugin wraps target node children with spans.
 * This is explicitly used for nodes which has backgroundColor styles on ThemeAPI
 * but actual background color needs to be applied as for inline text.
 */
export const createSpanWrapperDecorationPlugin = (targetNodeType: Node_Type) => {
  return new Plugin({
    key: new PluginKey(`${targetNodeType}-span-wrapper`),
    props: {
      decorations(state) {
        const decorations: Decoration[] = [];

        state.doc.descendants((node, pos) => {
          if (node.type.name === targetNodeType) {
            node.forEach((childNode, childPos) => {
              if (childNode.type.name === 'hardBreak') {
                return;
              }
              const childStart = pos + childPos + 1;
              const childEnd = childStart + childNode.nodeSize;
              decorations.push(Decoration.inline(childStart, childEnd, { nodeName: 'span' }));
            });
          }
        });

        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
};
